var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',{attrs:{"align-center":""}},[_c('Avatar',{attrs:{"size":".5em","color":_vm.color || 'grey'}}),_c('span',{staticClass:"ml-2 font-weight-bold caption"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }